export default __webpack_public_path__ + "static/media/android.fcdc15e6.png";